import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface SortIconProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

const SortIcon: React.FC<SortIconProps> = ({ color, width = 18, height = 18, className }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25 4.5H15.75M2.25 9H15.75M2.25 13.5H15.75"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="4.5" cy="4.5" r="1.5" fill={currentColor} />
      <circle cx="13.5" cy="9" r="1.5" fill={currentColor} />
      <circle cx="4.5" cy="13.5" r="1.5" fill={currentColor} />
    </svg>
  );
};

export default SortIcon;
